export default __webpack_public_path__ + "static/media/Answer_Icon.b113fa7e.svg";